import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { Icon } from "./icon";

/** Nothing here yet: a 40 px icon tile, a one-line title, and a sentence saying how the list fills. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center gap-1.5 px-2 py-8 text-center", className)}>
      <span
        aria-hidden="true"
        className="mb-1.5 inline-flex size-10 items-center justify-center rounded-[10px] bg-muted text-ink-muted"
      >
        <Icon icon={icon} size={20} />
      </span>
      <p className="font-semibold text-ink">{title}</p>
      {description !== undefined && <p className="max-w-sm text-small text-ink-muted">{description}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
